import ClassNames from 'classnames';
import React from 'react';

import i18n from '@shared/i18n/index';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { loading_color } from '@shared/assets/svg/common';

import styles from './index.module.less';

interface LoadingProps {
	className?: string;
	style?: React.CSSProperties;
	icon?: string;
	color?: string;
	opacity?: number;
	size?: number;
	text?: string;
}

export const BaseLoadingV2 = (props: LoadingProps) => {
	const {
		className,
		style,
		icon,
		color = 'var(--theme-color-primary, var(--color-brand-400))',
		size = 40,
		text = i18n.get('Common_loading_text'),
	} = props;
	const loadingIcon = icon ? icon : loading_color;
	return (
		<div className={ClassNames(styles.loadingWrap, className)} style={style}>
			{/* <div dangerouslySetInnerHTML={{ __html: loadingIcon }} className={styles.rotate} /> */}
			<NewBaseIcon color={color} size={size} icon={loadingIcon} className={styles.rotate} />
			{!!text && <span className={styles.desc}>{text}</span>}
		</div>
	);
};
